//@flow
import React from "react";
import {Popover} from "antd";

import {MarkerContainer, MarkerIcon, SubCompanyContainer, SubCompanyIcon} from "../markerStyles";
import {MarkerPropType} from "../markerPropTypes";
import {Content} from "./Content";

export const PickupMarker = ({
    lat,
    lng,
    icon,
    color,
    pickupInfo,
    fromOrder,
    fromStore
}: MarkerPropType) => {
    return (
        <div data-testid="map_pickupMarker">
            {fromOrder && fromOrder?.includes(fromStore) ? null : typeof icon === "string" ? (
                <SubCompanyContainer lat={lat} lng={lng} zIndex={999}>
                    <Popover content={<Content pickupInfo={pickupInfo} />} trigger="click">
                        <SubCompanyIcon src={icon} color={color} />
                    </Popover>
                </SubCompanyContainer>
            ) : (
                <MarkerContainer lat={lat} lng={lng} color={color} zIndex={999}>
                    <Popover content={<Content pickupInfo={pickupInfo} />} trigger="click">
                        <MarkerIcon icon={icon} color={color} />
                    </Popover>
                </MarkerContainer>
            )}
        </div>
    );
};
